/**
 * Configuration for AI features in TinyMCE editor
 * This file contains functions to register AI-related icons and buttons
 */
import { customIcon } from 'components/TinymceEditor/icons/customIcon';

/**
 * Registers AI features in the TinyMCE editor if aiGenerateFunction is provided
 * @param {object} editor - The TinyMCE editor instance
 * @param {function|undefined} aiGenerateFunction - Optional function to handle AI generation
 * @returns {void}
 */
export const registerAiFeatures = (editor, aiGenerateFunction) => {
  // Always register the custom icon so it's available
  editor.ui.registry.addIcon('ai-custom-icon', customIcon);

  // Only register the button if aiGenerateFunction is provided
  if (aiGenerateFunction) {
    editor.ui.registry.addButton('ai-custom-button', {
      text: 'AI',
      icon: 'ai-custom-icon',
      tooltip: 'Compose with AI',
      classes: 'ai-button',
      type: 'button',
      async onAction() {
        editor.setProgressState(true);

        try {
          // Use the provided aiGenerateFunction instead of the mock Promise
          const result = await aiGenerateFunction(editor.getContent());

          // Use the result in the editor
          editor.insertContent(`<strong>${result}</strong>`);
        } catch (error) {
          // Handle error silently or show a user-friendly message
          editor.notificationManager.open({
            text: 'Error processing your request',
            type: 'error',
          });
        } finally {
          editor.setProgressState(false);
        }
      },
    });
  }
};
